import gql from "graphql-tag";

import { pageInfoFragment } from "./pageInfo";

export const pageheaderFragment = gql`
  fragment PageheaderFragment on PageHeader {
    id
    isDefault
    countdown
    created
    name
    pageHeaderId
    isTop
    located
    showType
    mainColor
    secondaryColor
  }
`;

export const pageheaderDetailFragment = gql`
  ${pageInfoFragment}
  fragment PageheaderDetailFragment on PageHeader {
    id
    isDefault
    isTop
    countdown
    pcCountdown
    mbCountdown
    languageOpt
    startDate
    endDate
    created
    updated
    name
    located
    pcContent
    mobileContent
    pageHeaderId
    pcContentFormatted
    mobileContentFormatted
    mainColor
    secondaryColor
    pcRollingDuration
    mbRollingDuration
    pageTypes(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          name
          url
          created
          publishedPage {
            isPublished
            status
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
    events {
      id
      user {
        email
      }
      action
      logs
      created
    }
  }
`;
